import { useConstant, type User } from '@talos/kyoko';
import { useEffect, type PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import type { AvaAppStore } from './AppStateProviderHooks';
import { ReduxDevToolsWrapper } from './ReduxDevTools';
import { getAppStateStore } from './getAppStateStore';
import { createUserInfoSlice } from './userInfoSlice';

export const AppStateProvider = ({
  children,
  user,
  store: testingStore,
}: PropsWithChildren<{
  user: User;
  store?: AvaAppStore | null; // Store can be passed in for testing purposes
}>) => {
  // Instantiate the userInfoSlice with a user to get it in its initial state. We then listen for user updates and keep userInfoSlice in sync.
  // The user changes for example when we you change roles or similar
  const userInfoSlice = useConstant(createUserInfoSlice(user));
  const store = useConstant(testingStore ?? getAppStateStore({ userInfoSlice }));
  useEffect(() => {
    store.dispatch(userInfoSlice.actions.setUser(user));
  }, [store, userInfoSlice, user]);
  return (
    <Provider store={store}>
      <ReduxDevToolsWrapper store={store} />
      {children}
    </Provider>
  );
};
